import React from "react";

import { BrieGPTConfig } from "../AddViewDrawer/AddViewDrawer";
import CustomToggle from "../../Drawers/Fields/CustomToggle";

export default function BrieGPTViewConfig({
  brieGPTConfig,
  setBrieGPTConfig,
}: {
  brieGPTConfig: BrieGPTConfig;
  setBrieGPTConfig: React.Dispatch<React.SetStateAction<BrieGPTConfig>>;
}) {
  return (
    <div className="pt-4">
      <CustomToggle
        title="Show All Projects/Chats"
        stateName="ShowAll"
        description={`Enabling this means all Projects/Chats from this cloud will be shown, not just the ones you create inside this view.`}
        value={brieGPTConfig.ShowAll}
        handleChange={(e: any) =>
          setBrieGPTConfig({ ...brieGPTConfig, ShowAll: e.target.checked })
        }
      />
    </div>
  );
}
